/**
 * Aqua Vitae Color Palette
 * Primary: Teal #088596 | Secondary: Green #307165
 */

export const primary = {
  main: '#A71C79',
  dark: '#7F125D',
  light: '#D270AE',
  30: '#E0B8D8',
  contrastText: '#FFFFFF',
}

export const secondary = {
  main: '#461163',
  dark: '#380D53',
  light: '#7C59B4',
  30: '#A98FE5',
  contrastText: '#FFFFFF',
}
export const success = { main: '#22C55E', light: '#CDFACA', dark: '#016A1C' }
export const warning = { main: '#F59E0B', light: '#FFE8B1', dark: '#943C00' }
export const error = { main: '#EF4444', light: '#FFB6BC', dark: '#8D000C' }
export const info = { main: '#3B82F6', light: '#E3F4F4', dark: '#053B47' }
